export const inArray = (valueOrValueList = '', list = [], matchAll = false) => {
  if (!Array.isArray(valueOrValueList)) {
    return list.includes(valueOrValueList)
  }

  return valueOrValueList[matchAll ? 'every' : 'some'](i => list.includes(i))
}
